import React, { useState, useEffect } from 'react'
import { Table, Button, Modal, Input, Space, Select, Switch } from 'antd'
import {
  PlusOutlined,
  EditOutlined,
  SearchOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import axios from 'axios'

import {
  GetCasteMaster,
  CreateCasteMaster,
  UpdateCasteMaster,
  GetReligionMaster,
  DeleteCasteMaster,
} from '../../../AllAPI/AdminAPI'

import { toast } from 'react-toastify'

const CasteMaster = () => {
  const storedBranchId = sessionStorage.getItem('branch_id')

  const [data, setData] = useState([])
  const [religions, setReligions] = useState([])
  const [searchText, setSearchText] = useState('')
  const [loading, setLoading] = useState(false)

  // useState inputs
  const [religionId, setReligionId] = useState(null)
  const [caste, setCaste] = useState('')

  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false)
  // const [deleteId, setDeleteId] = useState(null)
  const [editingId, setEditingId] = useState(null)

  useEffect(() => {
    fetchReligions()
    fetchCastes()
  }, [])

  // Load religions (for dropdown)
  const fetchReligions = async () => {
    try {
      const res = await axios.get(`${GetReligionMaster}`)
      setReligions(res.data)
    } catch (err) {
      toast.error('Failed to load religions')
    }
  }

  // Load Castes
  const fetchCastes = async () => {
    setLoading(true)
    try {
      const res = await axios.get(GetCasteMaster)

      const formatted = res.data.map((item, index) => ({
        key: item.cast_id,
        index: index + 1,
        cast_name: item.cast_name,
        religion_name: item.religion?.religion_name || 'N/A',
        religion_id: item.religion_id,
      }))

      setData(formatted)
    } catch (err) {
      toast.error('Failed to load castes')
    } finally {
      setLoading(false)
    }
  }

  // Open modal for Add/Edit
  const handleOpenModal = (record = null) => {
    if (record) {
      setEditingId(record.key)
      setReligionId(record.religion_id)
      setCaste(record.cast_name)
    } else {
      setEditingId(null)
      setReligionId('')
      setCaste('')
    }
    setIsModalOpen(true)
  }

  // Save / Update
  const handleSave = async () => {
    if (!religionId) return toast.error('Please select a Religion')
    if (!caste.trim()) return toast.error('Please enter Caste')

    const payload = {
      religion_id: religionId,
      cast_name: caste,
    }

    try {
      if (editingId) {
        const res = await axios.put(
          `${UpdateCasteMaster}/${editingId}`,
          payload,
        )
        if (res.data === 'UPDATED') {
          toast.success('Caste updated successfully')
        }
      } else {
        const res = await axios.post(CreateCasteMaster, payload)
        if (res.data === 'SAVED') {
          toast.success('Caste added successfully')
        }
      }

      fetchCastes()
      setIsModalOpen(false)
      setEditingId(null)
      setReligionId('')
      setCaste('')
    } catch (err) {
      toast.error('Failed to save Caste')
    }
  }

  //   const handleDelete = async (id) => {
  //   try {
  //     const res = await axios.delete(`${DeleteCasteMaster}/${id}`);
  //     if (res.data === "NOTFOUND") {
  //       toast.warn("Caste not found!");
  //       fetchCastes();
  //     }
  //     else if (res.data === "DELETED") {
  //       toast.success("Caste deleted successfully");
  //       fetchCastes();
  //     }
  //   } catch (err) {
  //     toast.error("Failed to delete caste");
  //   }
  // };

  // const openDeleteModal = (id) => {
  //   setDeleteId(id);
  //   setIsDeleteModalOpen(true);
  // };

  // const confirmDelete = async () => {
  //   await handleDelete(deleteId);
  //   setIsDeleteModalOpen(false);
  //   setDeleteId(null);
  // };

  // Search filter

  const filteredData = data.filter((item) =>
    (item.cast_name + '').toLowerCase().includes(searchText.toLowerCase()),
  )

  const columns = [
    { title: 'Sr No', dataIndex: 'index' },
    { title: 'Religion', dataIndex: 'religion_name' },
    { title: 'Caste', dataIndex: 'cast_name' },
    {
      title: 'Actions',
      align: 'center',
      render: (_, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            size="small"
            onClick={() => handleOpenModal(record)}
          />
          {/* <Button
                icon={<DeleteOutlined />}
                danger
                size="small"
                onClick={() => openDeleteModal(record.key)}
            /> */}
        </Space>
      ),
    },
  ]

  return (
    <div className="form-container mainContainer">
      <div className="row p-0 m-0 pb-5">
        <div className="col-12 col-md-2"></div>
        <div className="col-12 col-md-8">
          <div className="header-row">
            <h2 className="page-title">Caste Master</h2>
          </div>

          <div className="search-bar">
            <Input
              placeholder="Search Caste..."
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
              style={{ width: 250 }}
            />

            <Button
              type="primary"
              className="mt-2 mt-md-0"
              icon={<PlusOutlined />}
              onClick={() => handleOpenModal()}
              style={{ marginLeft: 10 }}
            >
              Add Caste
            </Button>
          </div>

          <Table
            columns={columns}
            dataSource={filteredData}
            pagination={{ pageSize: 10 }}
            bordered
            loading={loading}
            scroll={{ x: 'max-content' }}
          />
        </div>
        <div className="col-12 col-md-2"></div>
      </div>

      {/* MODAL */}
      <Modal
        title={editingId ? 'Edit Caste' : 'Add Caste'}
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={[
          <Button key="cancel" onClick={() => setIsModalOpen(false)}>
            Cancel
          </Button>,
          <Button key="save" type="primary" onClick={handleSave}>
            Save
          </Button>,
        ]}
      >
        <div style={{ marginBottom: 15 }}>
          <label>Select Religion</label>
          <Select
            value={religionId}
            onChange={setReligionId}
            placeholder="Select Religion"
            style={{ width: '100%' }}
            disabled={!!editingId}
          >
            {religions.map((c) => (
              <Select.Option key={c.id} value={c.id}>
                {c.religion_name}
              </Select.Option>
            ))}
          </Select>
        </div>

        <div>
          <label>Caste</label>
          <Input
            value={caste}
            onChange={(e) => setCaste(e.target.value)}
            placeholder="Enter caste"
          />
        </div>
      </Modal>

      {/* ===DELETE MODAL==== */}
      {/* <Modal
                  title="Confirm Delete"
                  open={isDeleteModalOpen}
                  onCancel={() => setIsDeleteModalOpen(false)}
                  footer={[
                      <Button key="cancel" onClick={() => setIsDeleteModalOpen(false)}>
                      Cancel
                      </Button>,
                      <Button
                      key="delete"
                      danger
                      type="primary"
                      onClick={confirmDelete}
                      >
                      Delete
                      </Button>,
                  ]}
                  >
                  <p>Are you sure you want to delete this caste?</p>
                  </Modal> */}
    </div>
  )
}

export default CasteMaster
